import {
  Info as TheIcon
} from 'components/icons';

// OR
// import React from 'react';
// import { Icon } from "semantic-ui-react";

// function TheIcon (props) {
//   return <Icon name="info" {...props} />;
// }

export const meta = {
  id: 'CMSTags',
  title: 'CMSTags',
  category: 'CMS',
  exposes: [],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Tags used by CMS`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
